import { api } from './authService';

export const taskService = {
  getTasks: (channelId) => api.get(`/project/${channelId}/tasks`).then(res => res.data),
  createTask: (channelId, task) => api.post(`/project/${channelId}/tasks`, task).then(res => res.data),
  updateTask: (taskId, task) => api.put(`/project/${taskId}`, task),
  deleteTask: (taskId) => api.delete(`/project/${taskId}`),
  moveTask: (taskId, area, position) => api.post(`/project/${taskId}/move`, { area, position }),
  reorder: (channelId, area, taskIds) => api.post(`/project/${channelId}/reorder`, { area, taskIds })
};